module.exports = __webpack_public_path__ + "img/WZN.f057aa78.png";